<template>
  <div class="variants-wrapper">
    <div v-for="(key, idx) in keys" :key="idx">
      <UpToDate :onLive="item[key].on_live" :publishDate="item[key].publish_date" :outdated="item[key].outdated" :nodeId="item[key].node_id" :publishUri="item[key].uri" :reimport="false">
        <a :href="item[key].uri" :title="item[key].title" target="_blank" :aria-label="LANG.previewOpensBlank">{{ item[key].description || item[key].uri }}</a>
      </UpToDate>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapState } from 'vuex';

import UpToDate from '@/components/browser/views/details/UpToDate.vue';

export default defineComponent({
  components: {
    UpToDate,
  },
  props: {
    item: Object,
  },
  computed: {
    ...mapState(['LANG']),
    keys() {
      if (!this.item) return [];

      return Object.keys(this.item);
    },
  },
  methods: {
    icon(key) {
      return !this.item[key].outdated ? 'fa-check-square' : 'fa-exclamation-circle';
    },
  },
});
</script>

<style scoped lang='scss'>
.variants-wrapper {
  display: flex;
  flex-direction: column;

  a {
    margin-right: 5px;
  }
}

.fa5 {
  right: 0px;
  float: right;
}
.fa-check-square {
  color:#26BF4B;
}
.fa-exclamation-circle {
  color: $red;
}
</style>
